export const CyApp = {
  UserChangedContinueButton: "UserChangedContinueButton",
  UserChangedTitle: "UserChangedTitle",
  ShowCrewButton: "ShowCrewButton",
  ManageSongsheetsButton: "ManageSongsheetsButton",
} as const;
